import { combineReducers } from '@reduxjs/toolkit';
import { all, fork } from 'redux-saga/effects';
import accordionStepsSaga from './accordion.saga';
import accordionstepsSlice from './accordion.slice';
import aftercareSaga from './aftercare.saga';
import aftercareSlice from './aftercare.slice';
import userInfoSaga from './userInfo.saga';
import userInfoSlice from './userInfo.slice';
export const aftercareReducer = combineReducers({
    step: accordionstepsSlice.reducer,
    afterCare: aftercareSlice.reducer,
    userInfo: userInfoSlice.reducer,
});
export function* aftercareRootSaga() {
    yield all([fork(accordionStepsSaga), fork(aftercareSaga), fork(userInfoSaga)]);
}
export const getAftercareInfo = (state) => state.afterCare;
